export const datasourcesTableHeaders = [
  {
    key: 'datasourceFormatted',
    isVisible: true,
  },
  {
    key: 'name',
    isVisible: false,
  },
  {
    key: 'email',
    isVisible: false,
  },
  {
    key: 'id',
    isVisible: false,
  },
  {
    key: 'organization',
    isVisible: false,
  },
  {
    key: 'timeFormatted',
    isVisible: true,
  },
  {
    key: 'time',
    isVisible: false,
  },
];
export const connectorsTableHeaders = [
  {
    key: 'connectorFormatted',
    isVisible: true,
  },
  {
    key: 'name',
    isVisible: false,
  },
  {
    key: 'email',
    isVisible: false,
  },
  {
    key: 'id',
    isVisible: false,
  },
  {
    key: 'organization',
    isVisible: false,
  },
  {
    key: 'timeFormatted',
    isVisible: true,
  },
  {
    key: 'time',
    isVisible: false,
  },
];
import { ROW, COLUMN, COMPONENT } from 'src/constants/general';
import { generateRandomString } from './general.helper';

// a little function to help us with reordering the result
export const reorder = (list: any, startIndex: any, endIndex: any) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed); // inserting task in new index

  return result;
};

export const remove = (arr: any, index: any) => [
  // part of the array before the specified index
  ...arr.slice(0, index),
  // part of the array after the specified index
  ...arr.slice(index + 1),
];

export const insert = (arr: any, index: any, newItem: any) => [
  // part of the array before the specified index
  ...arr.slice(0, index),
  // inserted item
  newItem,
  // part of the array after the specified index
  ...arr.slice(index),
];

/**
 * Sort array of objects based on another array
 */

export const mapOrder = (array: any[], order: any[], key: string) => {
  array.sort(function (a, b) {
    const A = a[key],
      B = b[key];

    if (order.indexOf(A) > order.indexOf(B)) {
      return 1;
    } else {
      return -1;
    }
  });

  return array;
};
export const arrayMove = (array: any, from: number, to: number) =>
  from < to
    ? [...array.slice(0, from), ...array.slice(from + 1, to + 1), array[from], ...array.slice(to + 1)]
    : [...array.slice(0, to), array[from], ...array.slice(to, from), ...array.slice(from + 1)];

export const reorderChildren = (children: any, splitDropZonePath: any, splitItemPath: any) => {
  if (splitDropZonePath.length === 1) {
    const dropZoneIndex = Number(splitDropZonePath[0]);
    const itemIndex = Number(splitItemPath[0]);
    return reorder(children, itemIndex, dropZoneIndex);
  }

  const updatedChildren = [...children];

  const curIndex = Number(splitDropZonePath.slice(0, 1));

  // Update the specific node's children
  const splitDropZoneChildrenPath = splitDropZonePath.slice(1);
  const splitItemChildrenPath = splitItemPath.slice(1);
  const nodeChildren = updatedChildren[curIndex];
  updatedChildren[curIndex] = {
    ...nodeChildren,
    children: reorderChildren(nodeChildren.children, splitDropZoneChildrenPath, splitItemChildrenPath),
  };

  return updatedChildren;
};

export const removeChildFromChildren = (children: any, splitItemPath: any) => {
  if (splitItemPath.length === 1) {
    const itemIndex = Number(splitItemPath[0]);
    return remove(children, itemIndex);
  }

  const updatedChildren = [...children];

  const curIndex = Number(splitItemPath.slice(0, 1));

  // Update the specific node's children
  const splitItemChildrenPath = splitItemPath.slice(1);
  const nodeChildren = updatedChildren[curIndex];
  updatedChildren[curIndex] = {
    ...nodeChildren,
    children: removeChildFromChildren(nodeChildren.children, splitItemChildrenPath),
  };

  return updatedChildren;
};

export const addChildToChildren = (children: any, splitDropZonePath: any, item: any) => {
  if (splitDropZonePath.length === 1) {
    const dropZoneIndex = Number(splitDropZonePath[0]);
    return insert(children, dropZoneIndex, item);
  }

  const updatedChildren = [...children];

  const curIndex = Number(splitDropZonePath.slice(0, 1));

  // Update the specific node's children
  const splitItemChildrenPath = splitDropZonePath.slice(1);
  const nodeChildren = updatedChildren[curIndex];
  updatedChildren[curIndex] = {
    ...nodeChildren,
    children: addChildToChildren(nodeChildren.children, splitItemChildrenPath, item),
  };

  return updatedChildren;
};

export const handleMoveWithinParent = (layout: any, splitDropZonePath: any, splitItemPath: any) => {
  return reorderChildren(layout, splitDropZonePath, splitItemPath);
};

export const handleAddColumDataToRow = (layout: any) => {
  const layoutCopy = [...layout];
  const COLUMN_STRUCTURE = {
    type: COLUMN,
    id: generateRandomString(8),
    children: [],
  };

  return layoutCopy.map((row) => {
    if (!row.children.length) {
      row.children = [COLUMN_STRUCTURE];
    }
    return row;
  });
};

export const handleMoveToDifferentParent = (layout: any, splitDropZonePath: any, splitItemPath: any, item: any) => {
  let newLayoutStructure;
  const COLUMN_STRUCTURE = {
    type: COLUMN,
    id: generateRandomString(8),
    children: [item],
  };

  const ROW_STRUCTURE = {
    type: ROW,
    id: generateRandomString(8),
  };

  switch (splitDropZonePath.length) {
    case 1: {
      // moving column outside into new row made on the fly
      if (item.type === COLUMN) {
        newLayoutStructure = {
          ...ROW_STRUCTURE,
          children: [item],
        };
      } else {
        // moving component outside into new row made on the fly
        newLayoutStructure = {
          ...ROW_STRUCTURE,
          children: [COLUMN_STRUCTURE],
        };
      }
      break;
    }
    case 2: {
      // moving component outside into a row which creates column
      if (item.type === COMPONENT) {
        newLayoutStructure = COLUMN_STRUCTURE;
      } else {
        // moving column into existing row
        newLayoutStructure = item;
      }

      break;
    }
    default: {
      newLayoutStructure = item;
    }
  }

  let updatedLayout = layout;
  updatedLayout = removeChildFromChildren(updatedLayout, splitItemPath);
  updatedLayout = handleAddColumDataToRow(updatedLayout);
  updatedLayout = addChildToChildren(updatedLayout, splitDropZonePath, newLayoutStructure);

  return updatedLayout;
};

export const handleMoveSidebarComponentIntoParent = (layout: any, splitDropZonePath: any, item: any) => {
  let newLayoutStructure;
  switch (splitDropZonePath.length) {
    case 1: {
      newLayoutStructure = {
        type: ROW,
        id: generateRandomString(8),
        children: [{ type: COLUMN, id: generateRandomString(8), children: [item] }],
      };
      break;
    }
    case 2: {
      newLayoutStructure = {
        type: COLUMN,
        id: generateRandomString(8),
        children: [item],
      };
      break;
    }
    default: {
      newLayoutStructure = item;
    }
  }

  return addChildToChildren(layout, splitDropZonePath, newLayoutStructure);
};

export const handleRemoveItemFromLayout = (layout: any, splitItemPath: any) => {
  return removeChildFromChildren(layout, splitItemPath);
};
